import { render, staticRenderFns } from "./Statistics.vue?vue&type=template&id=7422b4a0&scoped=true"
import script from "./Statistics.vue?vue&type=script&lang=js"
export * from "./Statistics.vue?vue&type=script&lang=js"
import style0 from "./Statistics.vue?vue&type=style&index=0&id=7422b4a0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7422b4a0",
  null
  
)

export default component.exports